export default function ColumnThatIsChildTableConstructor(col, tablePropsParams) {
    if (!col.name)
        console.error('col.name is required');
    if (!tablePropsParams.localEntityNameProp)
        console.error('tablePropsParams.localEntityNameProp is required');
    const res = Object.assign(Object.assign({ label: '', hideWhenCreating: true, style: 'width:200px', 
        // @ts-expect-error
        field: '' }, col), { isTable: true, 
        // @ts-ignore
        tableProps: Object.assign({ hideTitleProp: true, hideHeaderSlotProp: true, hideTopSlotProp: true, hideBottomSlotProp: true, suppressDraggableSortableProp: true, showAddButtonWhenDataIsEmptyProp: true, createByAddingRowProp: true, doNotFetchDataProp: true, isChildTableProp: true }, tablePropsParams // intends to overwite above default values
        ) });
    return res;
}
